import jwtInterceptor from "@/shared/jwtInterceptor";

const apiUrl= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

export class AppApi
{
  static async getStates()
  {
    const url = apiUrl + 'admin/app/getState';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data.states
    }
  };

  static async getCitiesByStateId(stateId)
  {
    const url = apiUrl + 'admin/app/getCitiesByStateId/'+stateId;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data.cities
    }
  };

  static async getPaymentTypeInfo(id)
  {
    const url = apiUrl + 'PaymentType/GetInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getProductAttributeForSelectAjax(str)
  {
    let url = apiUrl + 'ProductAttribute/getForSelectAjax';
    if (str)
      url += '?q='+str;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getAttributeValuesForSelect(attr_id)
  {
    let url = apiUrl + 'ProductAttribute/getItemsForSelect/'+attr_id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getUserFileForEdit(id)
  {
    let url = apiUrl + 'userFile/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getFiles(query,type,offset,number)
  {
    let url = apiUrl + 'admin/Filemanager/GetFiles?t=1';

    const response = await jwtInterceptor.post(url,{query,type,offset,number});
    if (response && response.data)
    {
      return response.data
    }
  }

  static async deleteFile(file_id)
  {
    let url = apiUrl + 'admin/Filemanager/Delete/'+file_id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getPlanInfoForEdit(id)
  {
    const url = apiUrl + 'admin/Plan/GetInfoFoEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getGuildInfoForEdit(id)
  {
    const url = apiUrl + 'admin/Guild/GetInfoFoEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getGuildsForSelect()
  {
    const url = apiUrl + 'admin/Guild/GetForSelect';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getCancelTransactionReasonInfo(id)
  {
    const url = apiUrl + 'admin/cancelTransactionReason/GetInfoFoEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getRejectOfferReasonInfo(id)
  {
    const url = apiUrl + 'admin/rejectOfferReason/GetInfoFoEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getMarketProductAttrInfo(id)
  {
    const url = apiUrl + 'admin/MarketProductAttr/GetInfoFoEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getRequestRegisterBrand(id)
  {
    const url = apiUrl + 'admin/RequestBrand/GetInfoFoEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getRequestRegisterProduct(id)
  {
    const url = apiUrl + 'admin/RequestProduct/getInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getMarketRequestInfoForEdit(id)
  {
    const url = apiUrl + 'admin/marketRequest/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getAuctionRequestInfoForEdit(id)
  {
    const url = apiUrl + 'admin/auctionRequest/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getTicketInfo(id)
  {
    const url = apiUrl + 'admin/Ticket/getTicketInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async closeTicket(id)
  {
    const url = apiUrl + 'admin/Ticket/closeTicket/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getUserForSelectAjax(str)
  {
    let url = apiUrl + 'admin/User/getUserForSelect';
    if (str)
      url += '?q='+str;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getUserMessageInfoForEdit(id)
  {
    const url = apiUrl + 'admin/Message/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getCountryForSelectAjax(str)
  {
    let url = apiUrl + 'admin/App/GetCountryForSelectAjax';
    if (str)
      url += '?q='+str;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getLearningPageHtml()
  {
    let url = apiUrl + 'admin/App/getLearningPageHtml';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getLawModalHtml()
  {
    let url = apiUrl + 'admin/App/getLawModalHtml';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getCoinCostInfo()
  {
    let url = apiUrl + 'admin/App/getCoinCostInfo';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getManagerForEdit(id)
  {
    let url = apiUrl + 'admin/Manager/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async deleteProductBrand(id)
  {
    let url = apiUrl + 'ProductBrand/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async deletePlan(id)
  {
    let url = apiUrl + 'admin/plan/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async deleteProductBrandAttribute(id)
  {
    let url = apiUrl + 'productAttribute/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteProductAttributeItem(id)
  {
    let url = apiUrl + 'productAttribute/deleteItem/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async deletePaymentType(id)
  {
    let url = apiUrl + 'paymentType/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteGuild(id)
  {
    let url = apiUrl + 'admin/Guild/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getProductCategoryInfoForDelete(id)
  {
    let url = apiUrl + 'admin/productCategory/getInfoForDelete/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }


  static async deleteProduct(id)
  {
    let url = apiUrl + 'admin/Product/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteCancelTransaction(id)
  {
    let url = apiUrl + 'admin/cancelTransactionReason/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteRejectOfferReason(id)
  {
    let url = apiUrl + 'admin/rejectOfferReason/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteMarketProductAttr(id)
  {
    let url = apiUrl + 'admin/MarketProductAttr/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteUser(id)
  {
    let url = apiUrl + 'admin/User/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteTicketDepartment(id)
  {
    let url = apiUrl + 'admin/TicketDepartment/delete/'+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getMarketRequestOfferInfo(id)
  {
    let url = apiUrl + 'admin/MarketRequestOffer/getInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getAuctionOfferInfo(id)
  {
    let url = apiUrl + 'admin/AuctionRequest/getOfferInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getPlansForSelect()
  {
    let url = apiUrl + 'admin/Plan/getAllPlans';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async ActivePlanForUser(data)
  {
    let url = apiUrl + 'admin/Plan/activeForUser';
    const response = await jwtInterceptor.post(url,data);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getProfileItems()
  {
    let url = apiUrl + 'admin/user/GetDashboardItems';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getRequestSpecialAccountInfoForEdit(id)
  {
    let url = apiUrl + 'admin/RequestSpecialAccount/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getProductCategoriesForSelectAjax(q,guild_id)
  {
    let url = apiUrl + 'admin/app/getProductCategoryGuildForSelect?t=1';
    if (q)
      url += '&q='+q;
    if (guild_id)
    {
      if (Array.isArray(guild_id))
      {
        for (let i = 0;i<guild_id.length;i++)
        {
          url += '&guild_id[]='+guild_id[i]._id;
        }
      }
    }
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getProductBrandForSelectAjax(q,guild_id)
  {
    let url = apiUrl + 'admin/app/getProductBrandGuildForSelect?t=1';
    if (q)
      url += '&q='+q;
    if (guild_id)
    {
      if (Array.isArray(guild_id))
      {
        for (let i = 0;i<guild_id.length;i++)
        {
          url += '&guild_id[]='+guild_id[i]._id;
        }
      }
    }
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getAllConfirmedUserForSelectAjax(q)
  {
    let url = apiUrl + 'admin/User/getAllConfirmedUserForSelectAjax';
    if (q)
      url += '?q='+q;

    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async submitDesktopExploreItems(data)
  {
    let url = apiUrl + 'admin/User/submitDesktopExploreItems';

    const response = await jwtInterceptor.post(url,data);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async submitMobileExploreItems(data)
  {
    let url = apiUrl + 'admin/User/submitMobileExploreItems';

    const response = await jwtInterceptor.post(url,data);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getExplorePageItems()
  {
      let url = apiUrl + 'admin/User/getExplorePageItems';

    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async submitExploreMenus(data)
  {
    let url = apiUrl + 'admin/User/submitExploreMenus';

    const response = await jwtInterceptor.post(url,data);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getExploreMenus()
  {
    let url = apiUrl + 'admin/User/getExploreMenus';

    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
}
